module.exports = __webpack_public_path__ + "img/7_newModelWorker_ljy.f2ea6e39.png";